import React, { Component } from 'react'
import { Modal, Table, Button, Input, DatePicker, InputNumber, Radio, message, Select, Icon, Avatar } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import dictCache from '../../../../common/dictCache';
import ExportUtil from '../../../../common/ExportUtil';
import genOperationAuth from '../../../common/genOperationAuth';
import moment from 'moment';
import TableC from '../../../basicElement/TableC';
import Text from '../../../basicElement/Text';
import UploadFile from '../../../common/UploadFile';

const RadioGroup = Radio.Group;
const { Option } = Select; 
const config = {
    'calculateType': [
        { label: '按金额', value: 'RATE_TO_AMOUNT' },
        { label: '按比例', value: 'AMOUNT_TO_RATE' },
    ],
    'expenseTypeId': [],
}

export default class NodeModel extends Component {
    state = {
        visible: false,
        loading: false,
        recordData:{},
        isMainPM: 0,
        data: [],
        isBoTal: false,
    }

    dictLoaded = false

    show = (recordData, isBoTal) => {
        // 字典与项目数据无关，首开一次；请求失败则下次打开自动重试
        if (!this.dictLoaded) {
            this.queryContractRemittanceDictByType('Expense_Type')
        }
        this.setState({ visible: true, recordData, isBoTal },this.loadData);
    }

    queryContractRemittanceDictByType = dictType => {
        dictCache.getDict(`REMITTANCE_DICT_${dictType}`, cb => {
            $.sendRequest({
                url: API_URL.contract.queryContractRemittanceDictByType,
                data: { dictType },
                dataType: 'json',
                doneResult: res => cb(res),
                errorResult: err => {
                    console.error(err);
                },
            });
        }, res => {
            const { data = [] } = res;
            config['expenseTypeId'] = [];
            data.forEach( el => {
            config['expenseTypeId'].push({ label: el.dictName, value: el.contractRemittanceDictId })
        })
            this.dictLoaded = true;
        });
    }

    totalData = data => {
        const { recordData:{ initialContractAmount, jdeContractAmount, negativeAmount } } = this.state;
        const newData = [...data]
        const totalData = {
            indexNum:'合计',
            noBtn: true,
            initialContractAmount,
            jdeContractAmount,
            negativeAmount,
            canApplyAmount: jdeContractAmount + negativeAmount,
            cashReqRate:0,
            remittanceAmount:0,
            remittanceCnyAmount:0,
        };
        data.forEach(el => {
            totalData.cashReqRate = (totalData.cashReqRate + (el.cashReqRate ? Number(el.cashReqRate) : 0)).toFixed(2) * 1;
            totalData.remittanceAmount = (totalData.remittanceAmount + (el.remittanceAmount ? Number(el.remittanceAmount) : 0)).toFixed(2)* 1;
            totalData.remittanceCnyAmount = (totalData.remittanceCnyAmount + (el.remittanceCnyAmount ? Number(el.remittanceCnyAmount) : 0)).toFixed(2)* 1;
        });
        if(data.length) newData.push(totalData); 
        return newData
    }

    loadData = () => {
        const { recordData:{ investigationJdeContractId } } = this.state;
        const options = {
            url: API_URL.contract.queryContractRemittanceNodes,
            data: {investigationJdeContractId},
            dataType: 'json',
            doneResult: res => {
                const { isMainPM } = res;
                res.data.forEach( (el,index) => {
                    el.indexNum = index + 1
                    el.isEdit = false
                } )
                this.setState({ data: res.data, isMainPM})
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleCancel = () => {
        this.setState({
            visible: false,
            loading: false,
            recordData:{},
            isMainPM: 0,
            data: [],
        });
    }

    handleChange = ( value, key, index ) => {
        const { data, recordData:{ exchangeRate, initialContractAmount, jdeContractAmount, negativeAmount } } = this.state;
        const {
            calculateType,
            cashReqRate,
            remittanceCnyAmount,
            canApplyAmount,
            remittanceAmount,
        } = data[index];
        data[index][key] = value;
        if(key == 'calculateType') {
            data[index].cashReqRate = null;
            data[index].remittanceAmount = null;
            data[index].remittanceCnyAmount = null;
        }
        if(key == 'cashReqRate' && calculateType == 'AMOUNT_TO_RATE') {
            data[index].remittanceCnyAmount = (jdeContractAmount + negativeAmount) * (value / 100);
            data[index].remittanceAmount = (initialContractAmount + negativeAmount) * (value / 100);
            data[index].remittanceCnyAmount = Number.isNaN(data[index].remittanceCnyAmount) ? '' : myFixed(data[index].remittanceCnyAmount,2);
            data[index].remittanceAmount = Number.isNaN(data[index].remittanceAmount) ? '' : myFixed(data[index].remittanceAmount,2);
        }
        if(key == 'remittanceAmount' && calculateType == 'RATE_TO_AMOUNT') {
            data[index].cashReqRate = (value * exchangeRate) * 100 / (jdeContractAmount + negativeAmount);
            data[index].remittanceCnyAmount = value * exchangeRate;
            data[index].cashReqRate = Number.isNaN(data[index].cashReqRate) ? '' : myFixed(data[index].cashReqRate,2);
            data[index].remittanceCnyAmount = Number.isNaN(data[index].remittanceCnyAmount) ? '' : myFixed(data[index].remittanceCnyAmount,2);
        }
        if(key == 'remittanceCnyAmount' && calculateType == 'RATE_TO_AMOUNT') {
            data[index].cashReqRate = value * 100 / (jdeContractAmount + negativeAmount);
            data[index].remittanceAmount = value / exchangeRate;
            data[index].cashReqRate = Number.isNaN(data[index].cashReqRate) ? '' : myFixed(data[index].cashReqRate,2);
            data[index].remittanceAmount = Number.isNaN(data[index].remittanceAmount) ? '' : myFixed(data[index].remittanceAmount,2);
        }
        this.setState({ data })
        
        function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }
    }

    handleDateChange = ( value, key, index ) => {
        const { data } = this.state;
        data[index][key] = moment(value).format('YYYY-MM-DD');
        this.setState({ data })
    }

    tableRender = ( text, record, index, key, disabled = false ) => {
        const { isEdit } = record;
        let renderSpan = null;
        if(!isEdit) {
            renderSpan = text;
            if(key == 'milestoneDate') {
                renderSpan = text ? text.slice(0, 10) : '';
            }else if( key == 'calculateType' || key == 'expenseTypeId') {
                renderSpan = text ? config[key].find( el => { return el.value == text} ).label : '';
            }else if( key == 'cashReqRate'){
                renderSpan = text != null ? `${text}%` : '';
            }
            return renderSpan
        }
        switch(key){
            case 'cashReqNode':
                renderSpan = 
                <Input 
                    style={{width:'100%'}} 
                    value={text} 
                    onChange={ e => this.handleChange(e.target.value, key, index) }
                />
                break;
            case 'milestoneDate':
                renderSpan = 
                <DatePicker 
                    format={'YYYY-MM-DD'} 
                    style={{width:'100%'}} 
                    value={ text ? moment(text) : null } 
                    onChange={ (data, datastr) => this.handleChange(moment(datastr).format('YYYY-MM-DD'), key, index) }
                />
                break;
            case 'cashReqRate':
            case 'remittanceAmount':
            case 'remittanceCnyAmount':
            case 'cashReqNodeNum':
                renderSpan = 
                <InputNumber 
                    disabled={disabled} 
                    style={{width:'100%'}} 
                    precision={ key == 'cashReqNodeNum' ? 0 : 2 } 
                    value={text} 
                    onChange={ value => this.handleChange(value, key, index) }
                />
                break;
            case 'calculateType':
            case 'expenseTypeId':
                if(disabled) {
                    renderSpan = text ? config[key].find( el => { return el.value == text} ).label : '';
                    break;
                }
                renderSpan = 
                <RadioGroup
                    value={text} 
                    options={config[key]} 
                    onChange={ e => this.handleChange(e.target.value, key, index) } 
                />
                break;
        }
        return renderSpan
    }

    getColumns = () => {
        const { recordData:{currency} } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'indexNum',
            key: 'indexNum',
            width: 60,
            rendre: text => text
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 120,
            render: ( text, record, index ) => this.tableRender(text, record, index, 'cashReqNode' )
        }, {
            title: 'milestone日期',
            dataIndex: 'milestoneDate',
            key: 'milestoneDate',
            width: 120,
            render: ( text, record, index ) => this.tableRender(text, record, index, 'milestoneDate' )
        }, {
            title: '请款笔数',
            dataIndex: 'cashReqNodeNum',
            key: 'cashReqNodeNum',
            width: 80,
            render: ( text, record, index ) => this.tableRender(text, record, index, 'cashReqNodeNum' )
        }, {
            title: '合同额含税/人民币（元）',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 120,
        }, {
            title: '负值合同金额/人民币（元）',
            dataIndex: 'negativeAmount',
            key: 'negativeAmount',
            width: 120,
        }, {
            title: '实际可请款金额/人民币（元）',
            dataIndex: 'canApplyAmount',
            key: 'canApplyAmount',
            width: 120,
        }, {
            title: '合同约定请款计算方式',
            dataIndex: 'calculateType',
            key: 'calculateType',
            width: 120,
            render: ( text, record, index ) => this.tableRender(text, record, index, 'calculateType' )
        }, {
            title: '合同约定请款比例',
            dataIndex: 'cashReqRate',
            key: 'cashReqRate',
            width: 120,
            render: ( text, record, index ) => 
                this.tableRender(text, record, index, 'cashReqRate', ( !record.calculateType || record.calculateType == 'RATE_TO_AMOUNT') )
        }, {
            title: '合同约定请款金额/原币',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: ( text, record, index ) => 
                this.tableRender(text, record, index, 'remittanceAmount', (!record.calculateType || record.calculateType == 'AMOUNT_TO_RATE' || currency == '人民币(CNY)' ) )
        }, {
            title: '合同约定请款金额/人民币（元）',
            dataIndex: 'remittanceCnyAmount',
            key: 'remittanceCnyAmount',
            width: 120,
            render: ( text, record, index ) => 
                this.tableRender(text, record, index, 'remittanceCnyAmount', (!record.calculateType || record.calculateType == 'AMOUNT_TO_RATE' || currency !== '人民币(CNY)' ) )
        }, {
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            width: 120,
        }, {
            title: '是否发起请款',
            dataIndex: 'cashReq',
            key: 'cashReq',
            width: 120,
        }, {
            title: '费用类型',
            dataIndex: 'expenseTypeId',
            key: 'expenseTypeId',
            width: 100,
            render: ( text, record, index ) => this.tableRender(text, record, index, 'expenseTypeId', record.remittanceCode )
        }]
        columns.push({
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 120,
            render: (text, record, index) => {
                const { contractRemittanceNodeId, isEdit, noBtn } = record;
                const { isMainPM, isBoTal } = this.state;
                const { curRole } = sessionStorage;
                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: !isEdit && (isMainPM || isBoTal) && !noBtn,
                        editable: true,
                        event: () => this.edit(index),
                        roles: ['*'],
                    }],
                    ['submit', {
                        name: '保存',
                        display: isEdit && (isMainPM || isBoTal) && !noBtn,
                        editable: true,
                        event: () => this.submit(index),
                        roles: ['*'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: (isMainPM || isBoTal) && !noBtn,
                        editable: true,
                        event: () => this.delete(contractRemittanceNodeId, index),
                        roles: ['*'],
                    }],
                ]);
                return genOperationAuth(operationCorrespondRoles, curRole);
            }
        });
        return columns
    }

    edit = (index) => {
        const { data } = this.state;
        data[index].isEdit = !data[index].isEdit;
        this.setState({ data })
    }

    submit = (index) => {
        const { data, recordData:{currency, investigationJdeContractId} } = this.state;
        const {
            canApplyAmount, 
            cashReqNodeNum,
            milestoneDate,
            calculateType,
            cashReqRate,
            remittanceAmount,
            remittanceCnyAmount,
            cashReqNode,
            expenseTypeId,
            contractRemittanceNodeId,
        } = data[index];
        if(!cashReqNode){
            message.error('请输入请款节点！')
            return
        }
        if(!milestoneDate){
            message.error('请选择milestone日期！')
            return
        }
        if(!cashReqNodeNum) {
            message.error('请输入请款笔数！')
            return
        }
        if(!calculateType) {
            message.error('请选择合同约定请款计算方式！')
            return
        }else if( calculateType == 'AMOUNT_TO_RATE' && !cashReqRate) {
            message.error('请输入合同约定请款比例！')
            return
        }else if( calculateType == 'RATE_TO_AMOUNT' && currency !== '人民币(CNY)' && !remittanceAmount) {
            message.error('请输入合同约定请款金额/原币！')
            return
        }
        if(!remittanceCnyAmount){
            message.error('请输入合同约定请款金额/人民币！')
            return
        }
        if(!expenseTypeId){
            message.error('请选择费用类型！')
            return
        }
        // if(remittanceCnyAmount > canApplyAmount) {
        //     message.error('合同约定请款金额＞实际可请款金额，无法保存!')
        //     return
        // }
        const options = {
            url:  contractRemittanceNodeId ? API_URL.contract.modifyContractRemittanceNode : API_URL.contract.addContractRemittanceNode,
            data: {
                ...data[index],
                investigationJdeContractId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success('保存成功！');
                data[index].isEdit = !data[index].isEdit;
                this.setState({ data }, this.loadData)
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
        
    }

    delete = ( id, index ) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                if(!id) {
                    const { data } = this.state;
                    data.splice( index, 1 );
                    message.success('删除成功！');
                    this.setState({ data })
                    return
                }
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.contract.deleteContractRemittanceNode,
                    data: { contractRemittanceNodeId: id },
                    dataType: 'json',
                    doneResult: res => {
                        message.success('删除成功！');
                        this.loadData();
                    }
                });
            },
        });
    }
    
    downloadTap = () => {
        const { recordData:{ investigationJdeContractId } } = this.state;
        this.exportModelRef.show(investigationJdeContractId)
    }

    onUplodChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else {
                const uploadMes = {};
                uploadMes.errorFilePath=file.response.errorFilePath;
                uploadMes.success=file.response.success;
                uploadMes.fail=file.response.fail;
                Number(uploadMes.success) > 0 && this.loadData();
                this.uploadModelRef.show(uploadMes);

            }
        }
    }

    add = () => {
        const { data, recordData:{jdeContractAmount, negativeAmount} } = this.state;
        data.push({
            indexNum: data.length + 1,
            cashReqNodeNum: data.length + 1,
            isEdit: true,
            jdeContractAmount:jdeContractAmount,
            negativeAmount:negativeAmount,
            canApplyAmount: jdeContractAmount + negativeAmount,
        })
        this.setState({data})
    }

    render() {
        const { visible, data, loading, recordData:{investigationJdeContractCode}, isMainPM, isBoTal } = this.state;
        return (
            <Modal
                title="请款节点"
                visible={visible}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width={1200}
                bodyStyle={{ minHeight: 400, maxHeight: 800 }}
                footer={ <Button onClick={this.handleCancel}>关闭</Button> }
            >
                <div className='nodeModel'>
                    <div className='model-header'>
                        <div className='jde-code'>JDE项目号：{investigationJdeContractCode}</div>
                        {
                            (isMainPM == 1 || isBoTal) &&
                            <div className='btn-list'>
                                <Button type="primary" onClick={this.downloadTap}>下载模板</Button>
                                <UploadFile
                                    uploadUrl={API_URL.contract.importRemittanceNodes}
                                    showUploadList={false}
                                    onChange={this.onUplodChange}
                                >
                                    <Button type="primary" className='yellow-btn'>导入数据</Button>
                                </UploadFile>
                                <Button type="primary" onClick={this.add}>添加</Button>
                            </div>
                        }
                    </div>
                    <TableC
                        loading={loading}
                        scrollY={650}
                        data={this.totalData(data)}
                        columns={this.getColumns()}
                    />
                    <UploadModel ref={ el => this.uploadModelRef = el } />
                    <ExportModel ref={ el => this.exportModelRef = el } investigationJdeContractCode={investigationJdeContractCode}/>
                </div>
            </Modal>
        )
    }
}

class ExportModel extends Component {
    state={
        visible: false,
        nodeRecordNum: 5,
        exportType: 'xlsx',
        investigationJdeContractId: null,
    }

    show = ( investigationJdeContractId ) => {
        this.setState({ visible:true, investigationJdeContractId })
    }

    handleChange = ( value ) => {
        this.setState({ nodeRecordNum: value })
    }

    handleOk = () => {
        const { nodeRecordNum, exportType, investigationJdeContractId } = this.state;
        if( !nodeRecordNum ) {
            message.error('请输入请款节点记录数')
            return
        }

        ExportUtil.export({
            investigationJdeContractId,
            rows:nodeRecordNum,
            // exportType,
        }, null, API_URL.contract.exportRemittanceNodeTemplate);
        message.success('正在下载中!');
        this.handleCancel();
    }

    handleCancel = () => {
        this.setState({
            visible: false,
            nodeRecordNum: 5,
            exportType: 'xlsx',
            investigationJdeContractId: null,
    })
    }

    render() {
        const { visible, exportType, nodeRecordNum } = this.state;
        const { investigationJdeContractCode } = this.props;
        return (
            <Modal
                title='导出模板'
                visible={visible}
                width={400}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
            >
                <div className="exportModel" >
                    <div className='jde-code'>JDE项目号：{investigationJdeContractCode}</div>
                    <div className="form-list">
                        <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text asterisk={true} colon={true}>请款节点记录数</Text></label>
                            <div className='ui-text'>
                                <InputNumber min={0} value={nodeRecordNum} onChange={ value => this.handleChange(value) }/>
                            </div>
                        </div>
                        {/* <div className="form-item">
                            <label htmlFor="" className="ui-label"><Text asterisk={true} colon={true}>导出格式</Text></label>
                            <div className='ui-text'>
                                <Select
                                    placeholder="请选择"
                                    style={{width: 100}}
                                    onChange={value => this.handleChange(value, 'exportType')}
                                    value={exportType}
                                >
                                    <Option key={'xlsx'} value={'xlsx'}>xlsx</Option>
                                    <Option key={'xls'} value={'xls'}>xls</Option>
                                </Select>
                            </div>
                        </div> */}
                    </div>
                </div>
            </Modal>
        )
    }
}

class UploadModel extends Component {
    state={
        visible: false,
        uploadMes:{
            success:0,
            fail:0,
            error:0,
            errorFilePath:''
        },
    }

    show = uploadMes => {
        this.setState({ uploadMes, visible: true })
    }

    downErrorReport = (params)=>{
        ExportUtil.export(params, null, API_URL.contract.exportImportRemittanceNodeFailFile);
        message.success('正在下载中!')
    }

    render() {
        const { visible, uploadMes } = this.state;
        return (
            <Modal 
                visible={visible}
                width={400}
                footer={null}
                closable={false}
                >
                <div style={{padding:'0 10px'}}>
                    <div style={{fontSize:'14px',fontWeight:'700',padding:'10px 0'}}><Icon type="exclamation-circle" style={{color:'#faad14',marginRight:'10px',fontSize:'20px'}}/>本次导入的“请款节点”数据:</div>
                    <div style={{paddingLeft:'30px'}}>
                        <p>导入成功{uploadMes.success}条</p>
                        <p>导入失败{uploadMes.fail}条</p>
                    </div>
                    {/* <p>数据错误{uploadMes.errorNum}条</p> */}
                    <div style={{textAlign:'right',marginTop:'20px'}}>
                        <Button size={ uploadMes.fail == 0 ? 'primary' : 'large' } style={{margin:'0 5px',fontSize:'12px'}} 
                        onClick={()=>{this.setState({visible:false})}}>{ uploadMes.fail == 0 ? '确定' : '关闭' }</Button>
                        {
                            uploadMes.fail != 0 &&
                            <Button type="primary" size='large' style={{margin:'0 5px',backgroundColor:'#169bd5',fontSize:'12px',borderColor:'#169bd5'}} onClick={() => this.downErrorReport({errorFilePath: uploadMes.errorFilePath})}>下载错误报告</Button>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/NodeModel.js